module.exports = __webpack_public_path__ + "static/media/duedate_w.39b897e4.svg";